import {
  Attribute,
  GetTeamAttributeRequest,
} from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const getTeamAttribute = (
  req: Partial<GetTeamAttributeRequest>
): Promise<Attribute> =>
  request({
    url: '/service/userv2service/GetTeamAttribute',
    body: req,
  }).then((r) => r.body);
